import {cssStyleResponsive} from '../utils/propsUtils';

const BOLD_AMP = {
  normal: '400',
  lighter: '300',
  medium: '500',
  bold: '700'
};

const ALIGN_AMP = {
  inherit: '0',
  center: 'auto',
  left: '0',
  right: '0'
};

const marginAuto = (viewport, align) => {
  return `
    ${cssStyleResponsive(viewport, 'margin-left', align, ALIGN_AMP)}
    ${cssStyleResponsive(viewport, 'margin-right', align, ALIGN_AMP)}
    `;
};
/**
 "text": {
    "textColor": "#FFFFFF",
    "fontSize": 15,
    "bold": "normal"
  }
 * */
export const textCss = ({text, viewport}) => {
  const {textColor, fontSize, bold, align, lineHeight} = text || {};
  return `
    ${cssStyleResponsive(viewport, 'color', textColor)}
    ${cssStyleResponsive(viewport, 'font-size', fontSize, null, 'px')}
    ${cssStyleResponsive(viewport, 'font-weight', bold, BOLD_AMP)}
    ${cssStyleResponsive(viewport, 'text-align', align)}
    ${marginAuto(viewport, align)}
    ${cssStyleResponsive(viewport, 'line-height', lineHeight)}
  `;
};

